import { put, takeLatest } from "redux-saga/effects";
import { fetchSupportSuccess } from "./supportSlice";

import { getSupportData } from "@/api/faq";

export function* fetchSupportSaga() {
  // const { endPoint } = action.payload;
  // console.log('action -> ', action.payload);

  let response = null;

  response = yield getSupportData("faqSection");
  if (response) {
    console.log("Support Data", response);
    yield put(fetchSupportSuccess(response));
  } else {
    // yield put(fetchSupportFailure('Support Request Failed'));
  }
}

export function* watchFetchSupportSaga() {
  yield takeLatest("support/fetchSupport", fetchSupportSaga);
}
